import { __extends } from "tslib";
import React from 'react';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import IframePopup from '../IframePopup';
var BasePopup = /** @class */ (function (_super) {
    __extends(BasePopup, _super);
    function BasePopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMessage = function (event) {
            var expectedOrigin = Url.origin();
            if (event.origin !== expectedOrigin) {
                return;
            }
            if (!event.data || !event.data.type || event.data.type !== 'popup-iframe') {
                return;
            }
            ddt.log('shared', 'sisu popup got a cmd: ', event.data);
            switch (event.data.command) {
                case 'close':
                    _this.props.requestClose();
                    break;
                case 'redirect':
                    window.location.replace(event.data.params.url);
                    break;
                default:
            }
        };
        return _this;
    }
    BasePopup.prototype.render = function () {
        var _a = this.props, iframeSrc = _a.iframeSrc, width = _a.width, height = _a.height;
        return (React.createElement(IframePopup, { title: '', initialWidth: width, initialHeight: height, src: iframeSrc, onMessage: this.onMessage }));
    };
    return BasePopup;
}(React.Component));
export default BasePopup;
//# sourceMappingURL=BasePopup.js.map